import { Schema } from 'mongoose';

const singleItemSchema = new Schema({}, { discriminatorKey: 'kind', _id: false });
const wishlistSchema = new Schema({
  owner: {
    type: Schema.Types.ObjectId,
    ref: 'User',
    required: true,
    unique: true,
  },
  items: {
    type: [singleItemSchema],
    default: [],
    required: true,
  },
});

const itemsArray = wishlistSchema.path('items');

// @ts-ignore
itemsArray.discriminator(
  'serviceGroup',
  new Schema(
    {
      serviceGroup: {
        type: Schema.Types.ObjectId,
        ref: 'ServiceGroup',
        required: true,
      },
    },
    { _id: false },
  ),
);

// @ts-ignore
itemsArray.discriminator(
  'service',
  new Schema(
    {
      service: {
        type: Schema.Types.ObjectId,
        ref: 'Service',
        required: true,
      },
    },
    { _id: false },
  ),
);

export default wishlistSchema;
